import { TextBox } from '../../models/text-box';

export class TermLookUpEvent {

    searchTerm: string;
    startBox: TextBox;
    endBox: TextBox;
}
